import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Radio from '../Radio/Radio';
import DropdownItem from '../Dropdown/DropdownItem';
import { StyledPresetsContainer } from './styles';
import type { PresetsPanelProps } from './types';
const Presets = t0 => {
  const $ = _c(10);
  const {
    presets,
    onSelectPreset,
    activePresetValue
  } = t0;
  if (presets.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== activePresetValue || $[2] !== onSelectPreset || $[3] !== presets) {
    let t2;
    if ($[5] !== activePresetValue || $[6] !== onSelectPreset) {
      t2 = preset => {
        const isActive = activePresetValue === preset.value;
        const isDisabled = preset.disabled === true;
        return <DropdownItem key={preset.value} disabled={isDisabled} onClick={() => {
          onSelectPreset(preset);
        }} aria-label={`Select ${preset.label}`} aria-pressed={isActive} aria-disabled={isDisabled} control={<Radio checked={isActive} value={preset.value} />}>{preset.label}</DropdownItem>;
      };
      $[5] = activePresetValue;
      $[6] = onSelectPreset;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = presets.map(t2);
    $[1] = activePresetValue;
    $[2] = onSelectPreset;
    $[3] = presets;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <StyledPresetsContainer>{t1}</StyledPresetsContainer>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
Presets.displayName = 'Presets';
export default Presets;